import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setInitiationValue } from '../state/serviceInitActions';
import DynamicContentPres from 'src/ui/features/ServiceInit/presentational/DynamicContentPres';

class DynamicContentContainer extends React.Component {
  static propTypes = {
    /** Action to update add initiation value */
    setInitiationValue: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setInitiationValue('dynamicFormValues', {});
  }

  handleUpdateValue = (type, value) => {
    setInitiationValue(type, value);
  };

  handleOnChange = (formValues, elementId) => {
    this.props.setInitiationValue('dynamicFormValues', formValues);
  };

  render() {
    return <DynamicContentPres onChange={this.handleOnChange} updateValue={this.handleUpdateValue} {...this.props} />;
  }
}

const mapStateToProps = ({ serviceInit }) => ({
  dynamicContent: serviceInit.addInitiation.dynamicContent,
});

const mapDispatchToProps = {
  setInitiationValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicContentContainer);



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/containers/DynamicContentContainer.js